import { sportProviderMap } from './sport-providers';

const rootStyle = getComputedStyle(document.body);
const colorHypeYellow = rootStyle.getPropertyValue('--color-hype-yellow').trim() || '#EAFF51';
const colorTextOnHypeYellow = rootStyle.getPropertyValue('--color-text-on-hype-yellow').trim() || '#000000';
const isKrone = window.$arenaConfig?.isKrone;

const theme = {
	team: {
		display:        'flex',
		alignItems:     'center',
		justifyContent: 'center',
		minWidth:       '112px',
		padding:        '0 12px',
		height:         '56px',
		background:     isKrone ? '#242D40' : '#1F2024',
		color:          '#f8f8f8',
	},
	score: {
		display:        'flex',
		alignItems:     'center',
		justifyContent: 'center',
		width:          '126px',
		height:         '56px',
		background:     colorHypeYellow,
		color:          colorTextOnHypeYellow,
	},
	divider: {
		width: '8px',
	},
};

const getSportProvider = (event) => {
	const provider = sportProviderMap[event.sport.name];
	if (!provider) throw new Error(`Unable to resolve score provider for sport "${event.sport.name}"`);
	return provider;
};

const getScore = ({ event, tags, timestamp }) => getSportProvider(event).getScore({ event, tags, timestamp });

const getScoreZones = ({ event, tags }) => getSportProvider(event).getScoreZones({ event, tags });

const getScoreZone = ({ timestamp, event, tags, scoreZones = [] }) => {
	const zones = scoreZones || getScoreZones({ event, tags, scoreZones });
	if (!Array.isArray(zones) || zones.length === 0) return getScore({ event, tags, timestamp });
	const foundZone = zones.find((zone) => zone.start <= timestamp && zone.end >= timestamp);
	if (!foundZone) throw new Error(`Unable to find score zone for timestamp: ${timestamp}`);
	return foundZone;
};

const getScoreboardOutput = ({ event, tags, timestamp, scoreZones = [] }) => {
	const score = Object.values(getScoreZone({ timestamp, event, tags, scoreZones }).score);

	// Variant 1 - team context: [Team A][Score][Team B]
	if (event.participants.length === 2 && event.participants[0].context === 'team') {
		const homeScore = score.find((e) => e.participant.type === 'home');
		const guestScore = score.find((e) => e.participant.type === 'guest');

		const homeTeam = event.participants.find((participant) => participant.type === 'home');
		const guestTeam = event.participants.find((participant) => participant.type === 'guest');

		const labels = {
			home:  homeTeam?.participatable?.club?.code,
			guest: guestTeam?.participatable?.club?.code,
			score: `${homeScore.value} - ${guestScore.value}`,
		};

		return [
			{ text: labels.home, style: theme.team },
			{ text: labels.score, style: theme.score },
			{ text: labels.guest, style: theme.team },
		];
	}

	// default
	return [];
};

export { getScore, getScoreZone, getScoreZones, getScoreboardOutput };
